import React, { useState } from 'react'
import styled from 'styled-components'
import Logo from '@berlitz/logo'
import { Show, Hide } from '@berlitz/globals/lib/components/layout'
import MaxTopNav from '@berlitz/top-nav'
import formatMenu from './formatMenu'
import { graphql } from 'gatsby'
import { PartnerLogoWrapper, TopNavWrapper } from './styles'
import Spacer from '@berlitz/spacer'
import PhoneModal from '../PhoneModal'
import PhoneIcon from '@berlitz/streamline-icons/lib/bold/20-Phones-Mobile-Devices/01-Phone/Phone'

const CallUs = styled.button`
  cursor: pointer;
`
const IconContainer = styled.button`
  margin: auto;
`

const TopNav = ({
  menu,
  currentLanguage,
  alternateLanguages = [],
  partnerLogo,
  homeUrl,
  phoneNumbers,
  multiplePhoneButton,
  phoneModalFooter,
}) => {
  const [modalOpen, setModalOpen] = useState(false)
  const menuFormatted = formatMenu(menu)
  const phoneNumber =
    phoneNumbers[0]?.phone_number?.document?.data.phone_number || ''
  const multiNumber = phoneNumbers?.length > 1
  const phoneNumberClean = phoneNumber.replace(/ /g, '').replace(/-/g, '')
  const topBarLinks = []
  const callUsTitle = phoneNumbers[0]?.phone_number?.document?.data.external_link_title || 'Call Us'

  if (phoneNumber && multiNumber) {
    topBarLinks.push(
      <>
        <IconContainer>
          <PhoneIcon size="xs" color="brand01" />
        </IconContainer>
        <Spacer size="xs" left>
          <CallUs
            onClick={() => setModalOpen(true)}
            data-key="top-nav__call-us-button"
          >
            {multiplePhoneButton || 'Call Us'}
          </CallUs>
        </Spacer>
      </>
    )
  } else if (phoneNumber && !multiNumber) {
    topBarLinks.push(
      <a
        key="top-nav__phone"
        data-key="top-nav__phone"
        href={`tel:${phoneNumberClean}`}
      >
        {`${callUsTitle}: ${phoneNumber}`}
      </a>
    )
  }

  return (
    <TopNavWrapper>
      {multiNumber && (
        <PhoneModal
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          phoneNumbers={phoneNumbers}
          modalFooter={phoneModalFooter}
        />
      )}
      <MaxTopNav
        isDark
        sticky
        primaryLinks={menuFormatted}
        mobileLinks={menuFormatted}
        secondaryLinks={topBarLinks}
        telNumber={multiNumber ? '' : phoneNumber}
        activeLanguage={currentLanguage.label}
        languageLinks={
          alternateLanguages.length
            ? alternateLanguages.map(item => (
                <a key={`alternate-language-${item.label}`} href={item.url}>
                  {item.language}
                </a>
              ))
            : null
        }
        logo={
          <>
            <Show breaks={['xs', 'sm']}>
              <a href={homeUrl}>
                <Logo size="md" />
                {partnerLogo && (
                  <PartnerLogoWrapper>
                    <img alt="" src={partnerLogo} />
                  </PartnerLogoWrapper>
                )}
              </a>
            </Show>
            <Hide breaks={['xs', 'sm']}>
              <a href={homeUrl}>
                <Logo size="lg" />
                {partnerLogo && (
                  <PartnerLogoWrapper>
                    <img alt="" src={partnerLogo} />
                  </PartnerLogoWrapper>
                )}
              </a>
            </Hide>
          </>
        }
        stickyNavCta={
          multiNumber && (
            <button
              onClick={() => setModalOpen(true)}
              data-key="top-nav__sticky-call-us-button"
            >
              <PhoneIcon size="sm" color="brand01" />
              {multiplePhoneButton}
            </button>
          )
        }
      />
    </TopNavWrapper>
  )
}

export const query = graphql`
  query ($lang: String!) {
    prismicMenu(lang: { eq: $lang }) {
      data {
        body {
          ...Menu
        }
        phone_numbers {
          ...PhoneNumbers
        }
      }
    }
  }

  fragment Menu on PrismicMenuDataBodySlicesType {
    ... on PrismicMenuDataBodyMenuItem {
      primary {
        label
        anchor_link
        link {
          url
          document {
            ... on PrismicPage {
              id
              uid
              lang
              data {
                title
              }
            }
          }
        }
      }
      items {
        dropdown_label
        dropdown_link {
          url
          document {
            ... on PrismicPage {
              id
              uid
              lang
              url
              data {
                title
              }
            }
          }
        }
      }
    }
  }

  fragment PhoneNumbers on PrismicMenuDataPhoneNumbers {
    phone_number {
      document {
        ... on PrismicPhoneNumbers {
          id
          lang
          data {
            title
            phone_number
            phone_description {
              html
              richText
            }
            link_format
            external_link_title
            external_link_icon
          }
        }
      }
    }
  }
`

export default TopNav
